(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (document.body.classList.contains('kw-mobile-navigation-open')) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-scarf-quote"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('knollwoods-scarf-quote')) {
    class KnollwoodsScarfQuote extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.lifecycle = new AbortController();
        const signal = this.lifecycle.signal;
        const form = this.querySelector('form');
        const inquiry = this.querySelector('.ksq-inquiry');
        const heading = inquiry.querySelector('h2');
        const quantity = form.elements.namedItem('contact[Quantity]');
        const designOptions = [...form.querySelectorAll('[data-design-option]')];
        const designDefault = form.querySelector('[data-design-default]');
        const clearDesign = form.querySelector('[data-clear-design]');
        const colorNotes = form.elements.namedItem('contact[Preferred colors]');
        let autoColorNote = '';
        const estimate = form.querySelector('.ksq-estimate');
        const status = form.querySelector('.ksq-submit-status');
        const copy = JSON.parse(this.querySelector('[data-quote-copy]').textContent);
        const colorChart = this.querySelector('.ksq-color-chart');
        const openChart = this.querySelector('[data-color-chart-open]');
        const closeChartButtons = [...colorChart.querySelectorAll('[data-color-chart-close]')];
        const colorChoices = [...colorChart.querySelectorAll('[data-stock-color]')];
        const colorFields = [...form.querySelectorAll('[data-stock-color-field]')];
        const selectedColors = form.querySelector('[data-selected-colors]');
        const colorSelectionStatus = colorChart.querySelector('[data-color-selection-status]');
        const clearColors = colorChart.querySelector('[data-clear-colors]');
        const syncColors = () => {
          const selected = colorChoices.filter(input => input.checked).slice(0, 2);
          colorChoices.forEach(input => {
            input.checked = selected.includes(input);
            input.disabled = selected.length === 2 && !input.checked;
          });
          colorFields.forEach((input, index) => {
            input.value = selected[index]?.value || '';
            input.disabled = !input.value;
          });
          const note = selected.map(input => input.value).join(' + ');
          let rest = colorNotes.value;
          if (autoColorNote && rest.startsWith(autoColorNote)) rest = rest.slice(autoColorNote.length).replace(/^\s*·\s*/, '');
          colorNotes.value = note && rest ? `${note} · ${rest}` : note || rest;
          autoColorNote = note;
          selectedColors.textContent = selected.length
            ? `${copy.selectedStockColors} ${selected.map(input => input.value).join(' + ')}`
            : copy.noStockColors;
          colorSelectionStatus.textContent = copy.stockColorCounts[selected.length];
          clearColors.disabled = selected.length === 0;
        };
        colorChoices.forEach(input => input.addEventListener('change', () => {
          syncColors();
        }, {signal}));
        const syncDesign = () => {
          const chosen = designOptions.some(input => input.checked);
          designDefault.disabled = chosen;
          clearDesign.hidden = !chosen;
        };
        designOptions.forEach(input => input.addEventListener('change', syncDesign, {signal}));
        clearDesign.addEventListener('click', () => {
          designOptions.forEach(input => {input.checked = false;});
          syncDesign();
          designOptions[0]?.focus();
        }, {signal});
        form.addEventListener('reset', () => queueMicrotask(syncDesign), {signal});
        syncDesign();
        clearColors.addEventListener('click', () => {
          colorChoices.forEach(input => {input.checked = false;});
          syncColors();
          colorChoices[0]?.focus();
        }, {signal});
        form.addEventListener('reset', () => queueMicrotask(syncColors), {signal});
        syncColors();
        this.colorChart = colorChart;
        openChart.addEventListener('click', () => {
          colorChart.showModal();
          document.documentElement.classList.add('ksq-color-chart-open');
          closeChartButtons[0].focus();
        }, {signal});
        closeChartButtons.forEach(button => button.addEventListener('click', () => colorChart.close(), {signal}));
        colorChart.addEventListener('close', () => {
          document.documentElement.classList.remove('ksq-color-chart-open');
          if (openChart.isConnected) openChart.focus({preventScroll:true});
        }, {signal});
        colorChart.addEventListener('click', event => {
          if (event.target !== colorChart) return;
          const rect = colorChart.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) colorChart.close();
        }, {signal});
        colorChart.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const first = closeChartButtons[0];
          const last = closeChartButtons[closeChartButtons.length - 1];
          if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
          else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
        }, {signal});
        const updateEstimate = () => {
          const value = Number(quantity.value);
          const valid = quantity.value !== '' && quantity.validity.valid && Number.isInteger(value);
          estimate.hidden = !valid;
          if (!valid) return;
          const money = new Intl.NumberFormat('en-US', {style:'currency',currency:'USD',maximumFractionDigits:0});
          form.querySelector('.ksq-estimate-value').textContent = money.format(value*Number(this.dataset.unitPrice));
        };
        quantity.addEventListener('input', updateEstimate, {signal});
        form.addEventListener('submit', event => {
          syncColors();
          if (!form.checkValidity()) {event.preventDefault();form.reportValidity();return;}
          status.textContent = copy.sending;
        }, {signal});
        window.addEventListener('pageshow', () => {
          status.textContent = '';
          syncColors();
          syncDesign();
          updateEstimate();
        }, {signal});
        const goToQuote = () => {
          inquiry.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
          heading.focus({preventScroll:true});
        };
        this.querySelectorAll('[data-quote-link]').forEach(link => link.addEventListener('click', event => {event.preventDefault();goToQuote();}, {signal}));
        this.querySelectorAll('[data-design-choice]').forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          designOptions.forEach(input => {input.checked = input.value === link.dataset.designChoice;});
          syncDesign();
          goToQuote();
        }, {signal}));
        const sticky = this.querySelector('.ksq-mobile-cta');
        if ('IntersectionObserver' in window) {
          this.setAttribute('data-sticky-ready','');
          let heroVisible = true;
          let formVisible = false;
          const refreshSticky = () => {sticky.hidden = heroVisible || formVisible;};
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.target === inquiry) formVisible = entry.isIntersecting;
              else heroVisible = entry.isIntersecting;
            });
            refreshSticky();
          });
          this.observer.observe(this.querySelector('.ksq-hero'));
          this.observer.observe(inquiry);
        }
        updateEstimate();
        const success = form.querySelector('.ksq-form-result-success');
        if (success) requestAnimationFrame(() => {
          success.scrollIntoView({block:'center'});
          success.focus({preventScroll:true});
        });
      }
      disconnectedCallback() {
        if (this.colorChart?.open) {
          this.colorChart.close();
          document.documentElement.classList.remove('ksq-color-chart-open');
        }
        this.lifecycle?.abort();
        this.observer?.disconnect();
        this.initialized = false;
      }
    }
    customElements.define('knollwoods-scarf-quote', KnollwoodsScarfQuote);
  }

  } catch(e) { console.error(e); }
})();
})();
